import Vue from "vue";

const state = () => ({
    containers: {},
    isAdvancedItemsLoading: {},
    configs: {},
    listCache: {},
    selectedProducts: {},
    dataPool: {}
})

const mutations =
    {
        setAdvancedItems(state, {lists, uid, variationId}) {
            if (!state.listCache[uid]) {
                state.listCache[uid] = []
            }
            if (!state.listCache[uid][variationId]) {
                state.listCache[uid][variationId] = lists
            }
        },

        setIsAdvancedItemsLoading(state, {isLoading, uid}) {
            state.isAdvancedItemsLoading[uid] = isLoading
        },

        setConfig(state, {config, uid}) {
            state.configs[uid] = config
        },

        addItemContainers(state, containers) {
            state.containers = { ...state.containers, ...containers };
        },

        addToDataPool(state, newDataPool) {
            state.dataPool = { ...state.dataPool, ...newDataPool };
        },

        setSelectedProduct(state, { uid, variationId, slotId, selectedProduct }) {
            if (!state.selectedProducts[uid]) {
                Vue.set(state.selectedProducts, uid, []);
            }
            if (!state.selectedProducts[uid][variationId]) {
                Vue.set(state.selectedProducts[uid], variationId, []);
            }
            Vue.set(state.selectedProducts[uid][variationId], slotId, selectedProduct);
        },

        resetSelectedProduct(state, { uid, variationId, slotId }) {
            if (state.selectedProducts[uid] && state.selectedProducts[uid][variationId]) {
                state.selectedProducts[uid][variationId][slotId] = null;
            }
        },

        preSelectProductsForAdhocSetSlots(state, {uid, variationId, entries}) {
            entries.forEach((selectedProduct, slotId) => {
                this.commit('setSelectedProduct', {uid, variationId, slotId, selectedProduct});
            });
        },
    }

const getters =
    {
        getContainerByVariationId: (state) => (variationId, containerKey) => {
            if (state.containers.hasOwnProperty(variationId)) {
                if (state.containers[variationId].hasOwnProperty(containerKey)) {
                    return state.containers[variationId][containerKey]
                }
            }
            return ''
        },

        isAdvancedItemsLoading: (state) => (uid) => {
            return state.isAdvancedItemsLoading[uid] || false;
        },

        getItemListsById: (state) => (uid, variationId) => {
            return state.listCache?.[uid]?.[variationId] || []
        },

        getConfigById: (state) => (uid) => {
            return state.configs[uid] || {};
        },

        getSelectedProductBySlotId: (state) => (uid, variationId, slotId) => {
            return state.selectedProducts?.[uid]?.[variationId]?.[slotId] || {};
        },

        getSelectedProducts: (state) => (uid, variationId) => {
            return state.selectedProducts?.[uid]?.[variationId] || [];
        },

        getItemListByEntryId: (state) => (uid, variationId, entryId) => {
            return state.listCache?.[uid]?.[variationId]?.[entryId] || []
        },

        getItemById: (state) => (id) => {
            return state.dataPool[id] || {};
        }
    }

const actions =
    {
        selectProduct: ({commit}, payload) => {
            commit('setSelectedProduct', payload)
        },

        resetSelectedProduct: ({commit}, payload) => {
            commit('resetSelectedProduct', payload)
        },

        async getAdvancedItems({commit, state}, {uid, data}) {
            if (state.listCache?.[uid]?.[data.currentItemId]) {
                return;
            }

            if (!state.configs[uid]) {
                commit('setConfig', {config: data.config, uid: uid});
            }

            commit('setIsAdvancedItemsLoading', {isLoading: true, uid: uid});
            try {
                const response = await fetch('/rest/ail/item-list', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(data),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const responseData = await response.json();

                if (responseData?.data) {
                    commit('setAdvancedItems', {
                        lists: responseData.data.lists,
                        uid: uid,
                        variationId: data.currentItemId,
                    });
                    commit('addItemContainers', responseData.data.containers);
                    commit('addToDataPool', responseData.data.dataPool);
                }
            } catch (error) {
                console.error("Error:", error);
                throw error;
            } finally {
                commit('setIsAdvancedItemsLoading', {isLoading: false, uid: uid});
            }
        },

        addBasketItems({ commit }, basketItems)
        {
            return new Promise((resolve, reject) =>
            {
                commit("basket/setIsBasketLoading", true);

                basketItems.forEach(item => {
                    item.template = "Ceres::Basket.Basket";
                });

                ApiService.post("/rest/io/basket/items/", {basketItems: basketItems})
                    .done(response =>
                    {
                        commit("basket/setIsBasketLoading", false);
                        resolve(response);
                    })
                    .fail(error =>
                    {
                        commit("basket/setIsBasketLoading", false);
                        reject(error);
                    });
            });
        },
    }

export default {
    state,
    getters,
    actions,
    mutations
}
